// Module
var code = "<div class=\"md-whiteframe-z1 mn-module flex layout-column\"\n     mn-bind-html=\"payment/views/financial-statement-container.html\">\n</div>";
// Exports
module.exports = code;